import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Summary' })({
    root: {
        display: 'flex',
        flexDirection: 'column'
    },
    name: {
        color: '#8E8E8E',
        fontSize: 18,
        fontWeight: 400,
        lineHeight: '24px'
    },
    price: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 16,
        marginBottom: 24
    },
    primary: {
        color: '#FFF',
        fontSize: 28,
        fontWeight: 700,
        lineHeight: '32px'
    },
    secondary: {
        color: '#FFF',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '16px',
        marginTop: 4,
        marginBottom: 8
    },
    minor: {
        color: '#8E8E8E',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '16px'
    },
    _placeholder: {
        visibility: 'hidden',
        '&::after': {
            content: '"\\200B"'
        }
    },
    button: {
        marginTop: 'auto',
        color: '#fff',
        fontSize: 13,
        fontWeight: 500,
        lineHeight: '16px',
        borderRadius: 80,
        ['&:hover']: {
            opacity: 0.8
        }
    },
    text: {
        padding: '14px 20px'
    },
    outlined: {
        padding: '13px 19px',
        border: '1px solid #EEE !important'
    },
    contained: {
        padding: '14px 20px',
        background: '#2D2D2D !important'
    }
});
